import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, AlertCircle, PlugZap } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "-";
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  return m < 1 ? "agora" : m < 60 ? `há ${m} min` : `há ${Math.round(m / 60)} h`;
};

export const ApiAccounts = ({ rows: given }) => {
  const [rows, setRows] = useState(given || []);
  useEffect(() => { if (!given) api.get("/api-accounts").then((r) => setRows(r.data)); }, [given]);
  return (
    <div data-testid="api-accounts-card" className="bg-[#111827] border border-[#1F293D] rounded-xl p-5">
      <h3 className="text-base font-semibold text-slate-200 mb-1 flex items-center gap-2"><PlugZap className="h-4 w-4 text-emerald-400" /> Sincronização automática via API</h3>
      <p className="text-xs text-slate-500 mb-3">Roda sozinha no servidor a cada 15 min, sem extensão.</p>
      {!rows.length && <p data-testid="api-accounts-empty" className="text-xs text-slate-500">Nenhum token cadastrado ainda.</p>}
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.account} data-testid={`api-account-${r.account}`} className="px-3 py-2 rounded-lg bg-[#0F141F] border border-[#1F293D] text-xs">
            <div className="flex items-center justify-between">
              <span className="font-mono text-sm text-sky-300">{r.account}</span>
              {r.status === "ok"
                ? <span className="flex items-center gap-1 text-emerald-400"><CheckCircle2 className="h-3.5 w-3.5" /> {ago(r.last_success)}</span>
                : <span className="flex items-center gap-1 text-red-400"><AlertCircle className="h-3.5 w-3.5" /> erro</span>}
            </div>
            {r.customers != null && (
              <div className="mt-1 flex flex-wrap gap-x-4 text-slate-400 font-mono">
                <span>{r.customers.toLocaleString("pt-BR")} clientes</span>
                <span data-testid={`api-whatsapp-${r.account}`}>{(r.whatsapp || 0).toLocaleString("pt-BR")} WhatsApp</span>
                <span data-testid={`api-credits-${r.account}`}>{(r.credits ?? 0).toLocaleString("pt-BR")} créditos</span>
              </div>
            )}
            {r.status === "error" && <div className="mt-1 text-red-400/80 break-words">{r.error}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};
